import { useQuery } from '@tanstack/react-query'

import {
  EnrollmentDisplayVersionEnum,
  getDisplayVersion
} from '../../../api/enrollments/get-display-version'
import LoadingScreen from '../../../components/elements/loading/loading-screen'
import ChildBasicData, {
  EnrollmentChildBasicDataProps
} from '../../../components/pages/client-space/child-profile-view/child-basic-data'
import ChildHostFamilyData, {
  EnrollmentChildHostFamilyDataType
} from '../../../components/pages/client-space/child-profile-view/child-host-family-data'

type Props = {
  enrollmentPicturePath?: string
  childName?: string
  enrollment: EnrollmentChildHostFamilyDataType & EnrollmentChildBasicDataProps
  refetch: () => void
}

const ClientInformationChildProfileView = ({
  enrollment,
  enrollmentPicturePath,
  childName,
  refetch
}: Props) => {
  const { data: displayVersion } = useQuery({
    queryKey: ['display-version', enrollment.id],
    queryFn: () => {
      if (!enrollment.id) return { version: EnrollmentDisplayVersionEnum.SHORT }
      return getDisplayVersion(enrollment.id)
    },
    enabled: !!enrollment.id
  })

  if (!displayVersion) return <LoadingScreen />

  return (
    <div className="flex flex-col gap-3.5">
      <ChildBasicData
        enrollment={enrollment}
        enrollmentPicturePath={enrollmentPicturePath}
        childName={childName}
        refetch={refetch}
        displayVersion={displayVersion.version}
      />
      {displayVersion?.version === EnrollmentDisplayVersionEnum.LONG && (
        <ChildHostFamilyData enrollment={enrollment} />
      )}
    </div>
  )
}

export default ClientInformationChildProfileView
